// src/pages/Admin.js
import React, { useState } from "react";
import {
  FaTachometerAlt,
  FaImage,
  FaDog,
  FaPhotoVideo,
  FaCrown,
  FaBars,
  FaTimes,
} from "react-icons/fa";
import AdminPuppyManager from "../components/AdminPuppyManager/AdminPuppyManager";
import AdminHeroImageManager from "../components/AdminHomeHeroManager/AdminHomeHeroManager";
import AdminGalleryManager from "../components/AdminGalleryManager/AdminGalleryManager";
import AdminStudManager from "../components/AdminStudManager/AdminStudManager";
import "../styles/Admin.css";

export default function Admin() {
  const [activeSection, setActiveSection] = useState("dashboard");
  const [menuOpen, setMenuOpen] = useState(false);

  const sections = [
    { key: "dashboard", label: "Dashboard", icon: <FaTachometerAlt /> },
    { key: "hero", label: "Basic Info", icon: <FaImage /> },
    { key: "gallery", label: "Gallery", icon: <FaPhotoVideo /> },
    { key: "puppies", label: "Puppies", icon: <FaDog /> },
    { key: "studs", label: "Studs", icon: <FaCrown /> },
  ];

  function renderSection() {
    switch (activeSection) {
      case "puppies":
        return <AdminPuppyManager />;
      case "hero":
        return <AdminHeroImageManager />;
      case "gallery":
        return <AdminGalleryManager />;
      case "studs":
        return <AdminStudManager />;
      default:
        return (
          <div className="admin-card">
            <h2>{activeSection}</h2>
            <p>
              This is where the <b>{activeSection}</b> module will load.
            </p>
          </div>
        );
    }
  }

  return (
    <div className="admin-layout">
      {/* Sidebar */}
      <aside className={`admin-sidebar ${menuOpen ? "open" : ""}`}>
        <div className="admin-logo">DeClerck’s Goldens Admin</div>
        <nav>
          {sections.map((section) => (
            <button
              key={section.key}
              className={activeSection === section.key ? "active" : ""}
              onClick={() => {
                setActiveSection(section.key);
                setMenuOpen(false); // close menu on mobile after selecting
              }}
            >
              {section.icon} {section.label}
            </button>
          ))}
        </nav>
      </aside>

      {/* Main content */}
      <main className="admin-main">
        <header className="admin-header">
          <button
            className="menu-toggle"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            {menuOpen ? <FaTimes /> : <FaBars />}
          </button>
          <h1>
            {sections.find((s) => s.key === activeSection)?.label ||
              "Admin Dashboard"}
          </h1>
        </header>
        {renderSection()}
      </main>
    </div>
  );
}
